import { FleekError } from './FleekError';

type FleekFunctionStatusNotValidErrorOptions = Record<string, never>;

export class FleekFunctionStatusNotValidError extends FleekError<FleekFunctionStatusNotValidErrorOptions> {
  public name = 'FleekFunctionStatusNotValidError';

  toString = () => {
    return `The function status is invalid. Must be one of ACTIVE and INACTIVE`;
  };
}
